import * as React from 'react'
import { useDispatch } from 'react-redux'

import { closeModal } from 'src/modules/modal'

import Button from 'src/components/atoms/common/Button'
import Img from 'src/components/molecules/common/ResponsiveImage'

import * as styles from 'src/components/molecules/Modal/Restart/style.module.styl'

interface IProps {
  children?: React.ReactNode
  options?: {
    callback?: Function
  }
}

const Component: React.FC<IProps> = (props) => {
  const dispatch = useDispatch()

  const cancel = () => {
    dispatch(closeModal())
  }

  const restart = () => {
    dispatch(closeModal())
    props.options?.callback && props.options.callback()
  }

  return (
    <div className={styles.restart}>
      <div className={styles.restart_image}>
        <Img src="top/restart/img_1.png" alt="" />
      </div>
      <h2 className={styles.restart_title}>本当にトップに<br />戻りますか？</h2>
      <p className={styles.restart_description}>今までの入力した内容が<br />すべて破棄されます。</p>
      <div className={styles.restart_buttons}>
        <ul className={styles.buttons}>
          <li className={styles.buttons_item}>
            <Button className="cancel" handleClick={cancel}>キャンセル</Button>
          </li>
          <li className={styles.buttons_item}>
            <Button className="backToTop" handleClick={restart}>トップに戻る</Button>
          </li>
        </ul>
      </div>
    </div>
  )
}
export default Component
